import { AnimatePresence, motion } from 'framer-motion'
import PropTypes from 'prop-types'
import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import './SiteIntro/styles.scoped.scss'

const animations = {
  initial: { opacity: 0 },
  animate: { opacity: 1, transition: { delay: 0.3 } },
  exit: { opacity: 0 },
}

const animationsFade = {
  initial: { opacity: 0 },
  animate: { opacity: 1 },
  exit: { opacity: 0 },
}

const PageTransition = ({ children }) => {
  const [transitioning, setTransitioning] = useState(false)
  const location = useLocation()

  useEffect(() => {
    if (location.search && location.search.includes('hash')) {
      setTransitioning(false)
    } else {
      setTransitioning(true)

      setTimeout(() => {
        setTransitioning(false)
      }, 500)
    }
  }, [location])

  return (
    <>
      <AnimatePresence mode="wait">
        {transitioning && (
          <motion.div
            key="pageTransition"
            variants={animationsFade}
            initial="initial"
            animate="animate"
            exit="exit"
            className="h-full w-full intro-bg absolute left-0 top-0 z-40"
            transition={{ duration: 0.5 }}
          >
            <div className="page-transition"></div>
          </motion.div>
        )}
      </AnimatePresence>
      <AnimatePresence mode="wait">
        <motion.div
          key={location.pathname}
          variants={animations}
          initial="initial"
          animate="animate"
          exit="exit"
          className="z-1"
          transition={{ duration: 0.5 }}
        >
          {children}
        </motion.div>
      </AnimatePresence>
    </>
  )
}

PageTransition.propTypes = {
  children: PropTypes.any,
}

export default PageTransition
